import { render, staticRenderFns } from "./ReplicationStatus.vue?vue&type=template&id=84f9eff8&scoped=true&"
import script from "./ReplicationStatus.vue?vue&type=script&lang=js&"
export * from "./ReplicationStatus.vue?vue&type=script&lang=js&"
import style0 from "./ReplicationStatus.vue?vue&type=style&index=0&id=84f9eff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f9eff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84f9eff8')) {
      api.createRecord('84f9eff8', component.options)
    } else {
      api.reload('84f9eff8', component.options)
    }
    module.hot.accept("./ReplicationStatus.vue?vue&type=template&id=84f9eff8&scoped=true&", function () {
      api.rerender('84f9eff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/ReplicationStatus.vue"
export default component.exports